var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_641_18112",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 171,
    height: 171
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 171,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_641_18112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.016 144.016C173.867 112.165 173.867 60.5236 142.016 28.6722C110.165 -3.17916 58.5234 -3.17916 26.672 28.6722C-5.17935 60.5236 -5.17935 112.165 26.672 144.016C58.5234 175.868 110.165 175.868 142.016 144.016Z",
    stroke: "#FF6D00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.645 134.645C159.321 107.969 159.321 64.7192 132.645 38.0433C105.969 11.3674 62.7191 11.3674 36.0432 38.0433C9.36727 64.7192 9.36727 107.969 36.0432 134.645C62.7191 161.321 105.969 161.321 132.645 134.645Z",
    stroke: "#FF6D00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5 119.194C146.644 94.8072 141.583 60.3295 117.196 42.186C92.8088 24.0425 58.3311 29.1038 40.1876 53.4906C22.0441 77.8775 27.1054 112.355 51.4923 130.499C75.8791 148.642 110.357 143.581 128.5 119.194Z",
    stroke: "#FF6D00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.496 103.335C131.879 82.2636 122.404 57.575 101.333 48.1915C80.2616 38.808 55.573 48.2829 46.1895 69.3543C36.806 90.4256 46.2809 115.114 67.3523 124.498C88.4236 133.881 113.112 124.406 122.496 103.335Z",
    stroke: "#FF6D00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3489 114.85C100.096 114.85 112.862 102.084 112.862 86.3367C112.862 70.5894 100.096 57.8237 84.3489 57.8237C68.6016 57.8237 55.8359 70.5894 55.8359 86.3367C55.8359 102.084 68.6016 114.85 84.3489 114.85Z",
    stroke: "#FF6D00",
    strokeMiterlimit: 10
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleIcon);
export default __webpack_public_path__ + "static/media/circle-icon.a075b6c86422b9a7069cb192f379e1b2.svg";
export { ForwardRef as ReactComponent };